import pageMock from "@/mock/page.json";
import {pageContent} from "@/types/pageContent";

import {getDataMock} from "./_callApi";

export async function getPage(id: string): Promise<pageContent> {
  if (getDataMock()) {
    const page: pageContent = pageMock;
    console.log(id);
    return page;
  } else {
    const page: pageContent = pageMock;
    return page;
  }
}
